export const COPILOT_TOOLS = {
  EMPLOYEE_INFO: {
    NAME: 'setEmployeeInfoTool',
    DESCRIPTION:
      'Update employee basic information such as full name, date of birth, address, phone number, gender, job title and bio.',
  },
  CREATE_TRAINING_ASSIGN_SUPPORTER: {
    NAME: 'createTrainingAssignSupporterTool',
    DESCRIPTION:
      'Create/Update one training and assign supporters to support this training course for one employee.',
  },
  PROJECT_MEMBER: {
    NAME: 'inviteRemoveResumeProjectMemberTool',
    DESCRIPTION:
      'Invite, remove permanent, leave, resume or change role one employee into one project.',
  },
  ASSIGN_REVOKE_MENTOR_MENTEE: {
    NAME: 'assignRevokeMentorMenteeTool',
    DESCRIPTION: 'Assign mentor or supporter for one employee.',
  },
  PROJECT_INFO: {
    NAME: 'setProjectInfoTool',
    DESCRIPTION:
      'Create/Update project basic information such as project name and project description.',
  },
  PROJECT_TECH_STACK: {
    NAME: 'setProjectTechStackTool',
    DESCRIPTION:
      'Add or remove technical stack items from project. Supports operations like adding React, removing Angular, etc.',
  },
  PROJECT_MEMBERS: {
    NAME: 'setProjectMembersTool',
    DESCRIPTION:
      'Manage project members with various actions: invite, change role, mark as left, remove, or resume members.',
  },
  PROJECT_ACTIVITIES: {
    NAME: 'setProjectEventsTool',
    DESCRIPTION:
      'Manage project lifecycle events: kick-off, complete, resume, pause, release, go-live, archive, and unarchive.',
  },

  RICH_TEXT_DESCRIPTION_EDITOR: {
    NAME: 'normalizeBeforeSavingProjectDescriptionOrEventNotes',
    DESCRIPTION:
      'Normalize the project description or event/scheduled event desc/note with a rich text editor.',
  },
  REMOVE_MEMBER_PROJECT: {
    NAME: 'confirmBeforeRemovingProjectMembers',
    DESCRIPTION:
      'Ask user to confirm before permanently removing members from the project',
  },
  ARCHIVE_PROJECT_CONFIRM: {
    NAME: 'confirmBeforeArchivingProject',
    DESCRIPTION: 'Ask user to confirm before archiving the project',
  },
  DEACTIVATE_EMPLOYEE_CONFIRM: {
    NAME: 'confirmBeforeDeactivatingEmployee',
    DESCRIPTION:
      'Ask user to confirm before deactivating an employee account. Always call this tool first, the frontend performs the deactivation on confirmation.',
  },
};
